import { ExternalMatchRequestRule } from 'generated/graphql';

export const convertRulesToInput = (rules: ExternalMatchRequestRule[]) => {
  return rules.map((rule) => ({
    id: rule.id,
    type: rule.type,
    active: rule.active,
    minAmount: rule.minAmount,
    maxAmount: rule.maxAmount,
    employeeLocations: rule.employeeLocations || [],
    ...(rule.confidenceScore
      ? {
          confidenceScore: {
            operator: rule.confidenceScore.operator,
            value: rule.confidenceScore.value,
          },
        }
      : {}),
    startingAt: rule.startingAt,
    endingAt: rule.endingAt,
  }));
};
